import * as resolverModule from './autofillProfileResolver.cjs';

const resolver = resolverModule.default || resolverModule;

export const {
  isNonEmptyPrefillValue,
  normalizeHouseholdProfileData,
  stripStudentSpecificProfileFields,
  extractLegacyHelperValuesFromSavedSubmission,
  buildNewStudentAutofillProfile,
  resolveStudentIntakeFieldValue,
  resolveReturningInitialFieldValue
} = resolver;
